import { create } from 'zustand'

type CollapsedByUser = Record<string, boolean>

export interface SidebarPreferenceState {
    collapsedByUser: CollapsedByUser
    hydrate: (userId: string) => boolean
    setCollapsed: (userId: string, collapsed: boolean) => void
}

const STORAGE_PREFIX = 'turba-superadmin-sidebar:'

const buildStorageKey = (userId: string) => `${STORAGE_PREFIX}${userId}`

const isBrowser = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

export const useSidebarPreferenceStore = create<SidebarPreferenceState>((set) => ({
    collapsedByUser: {},
    hydrate: (userId: string) => {
        if (!userId || !isBrowser()) {
            return false
        }

        const raw = window.localStorage.getItem(buildStorageKey(userId))
        const collapsed = raw === 'collapsed'

        set((state) => ({
            collapsedByUser: {
                ...state.collapsedByUser,
                [userId]: collapsed,
            },
        }))

        return collapsed
    },
    setCollapsed: (userId: string, collapsed: boolean) => {
        if (!userId || !isBrowser()) {
            return
        }

        window.localStorage.setItem(buildStorageKey(userId), collapsed ? 'collapsed' : 'expanded')

        set((state) => ({
            collapsedByUser: {
                ...state.collapsedByUser,
                [userId]: collapsed,
            },
        }))
    },
}))

export const selectCollapsedByUser = (userId?: string | null) => (state: SidebarPreferenceState) => {
    if (!userId) {
        return false
    }

    return state.collapsedByUser[userId] ?? false
}
